/* eslint-disable */
const textLengthChecker = (text, length) => {
   return text.length > length ? text.substring(0, length) + ' ...' : text
}

const api = { textLengthChecker }

export default api;